export default {
    namespaced: true,
    state: {
        icon:{
            fl: require('../../assets/fl-icon.png'),
            fr: require('../../assets/fr-icon.png'),
            bl: require('../../assets/bl-icon.png'),
            br: require('../../assets/br-icon.png'),
            sl: require('../../assets/sl-icon.png'),
            sr: require('../../assets/sr-icon.png'),
        },
    }
}
